import Tone from 'tone'

let chimeTone = require('../assets/static/toneSection.mp3')
let typeTone = require('../assets/static/click_03.wav')
let deleteTone = require('../assets/static/click_delete.wav')
let dripTone = require('../assets/static/pop_hi.wav')
let dropTone = require('../assets/static/pop_drip_up.wav')

let violinC = require('../assets/static/toneC2.mp3')
let violinA = require('../assets/static/toneA2.mp3')
let violinF = require('../assets/static/toneF2.mp3')

let fingerFound = require('../assets/static/fingerFound.mp3')
let bassC = require('../assets/static/scanBaseC2.mp3')
let bassF = require('../assets/static/scanBaseF2.mp3')
let scanArp = require('../assets/static/breatheArp.mp3')
let breath = require('../assets/static/breath.mp3')

let waitArp = require('../assets/static/lightWait.mp3')


let players = {}

// Clicks and Types
players.chime = new Tone.Player(chimeTone).toMaster().set("volume", -12)
players.type = new Tone.Player(typeTone).toMaster().set("volume", -12)
players.delete = new Tone.Player(deleteTone).toMaster().set("volume", -12)
players.drip = new Tone.Player(dripTone).toMaster().set("volume", -12)
players.drop = new Tone.Player(dropTone).toMaster().set("volume", -6)
players.spot1 = new Tone.Player(violinC).toMaster().set("volume", -20)
players.spot2 = new Tone.Player(violinA).toMaster().set("volume", -20)
players.spot3 = new Tone.Player(violinF).toMaster().set("volume", -20)
players.bump = new Tone.Player(deleteTone).toMaster().set("volume", -18)

// Breathe sounds
players.finger = new Tone.Player(fingerFound).toMaster().set("volume", -12)
players.bassC = new Tone.Player(bassC).toMaster().set("volume", -18)
players.bassF = new Tone.Player(bassF).toMaster().set("volume", -18)
players.breath = new Tone.Player(breath).toMaster().set("volume", -30)
players.breath.loop = true

// Scan Sounds
players.scanArp = new Tone.Player(scanArp).toMaster().set("volume", -18)
players.scanArp.loop = true

// Wait Sounds
players.waitArp = new Tone.Player(waitArp).toMaster().set("volume", -18)
players.waitArp.loop = true
players.waitArp.loopEnd = 3

const install = (Vue, options) => {
    Vue.prototype.$tone = Tone
    
    Vue.prototype.$sound = (title, pitch, volume) => {

        if (title) {
            let sound = players[title]
            if (pitch) {
                sound.playbackRate = (1 + ((1/12)*pitch))
            } else {
                sound.playbackRate = 1
            }
            if (volume) sound.set("volume", volume)
            sound.start()
        }
    }
    
    Vue.prototype.$breatheAudio = (start) => {
        // Reset player volumes
        players.bassC.set("volume", -18)
        players.bassF.set("volume", -18)
        players.breath.set("volume", -38)
        // Set up Transport
        Tone.Transport.bpm.value = 120
        Tone.Transport.loop = true
        Tone.Transport.loopStart = "3m"
        Tone.Transport.loopEnd = "15:0:2"

        if (start) {
            console.log("BREATHE AUDIO")
            //set the transport
            players.bassC.sync().start("3m")
            players.bassF.sync().start("9:0:2")
            players.breath.sync().start()
            Tone.Transport.start()
        } else {
            // Turn it off
            // players.bassC.volume.rampTo(-80, 6)
            // players.bassF.volume.rampTo(-80, 6)
            // players.breath.volume.rampTo(-80, 6)
            // Chime it out!
            Vue.prototype.$sound('chime')
            players.bassC.stop()
            players.bassF.stop()
            players.breath.stop()
            Tone.Transport.stop()
            
            // setTimeout(() => {
            //     // Stop the transport
            //     players.bassC.stop()
            //     players.bassF.stop()
            //     players.breath.stop()
            //     Tone.Transport.stop()
            // }, 6000)
        }
    }
    Vue.prototype.$breatheCancel = () => {
        players.bassC.stop()
        players.bassF.stop()
        players.breath.stop()
        Tone.Transport.stop()
    }
    Vue.prototype.$waitAudio = (start) => {
        players.waitArp.set("volume", -18)
        if (start) {
            players.waitArp.start()
        } else {
            players.waitArp.volume.rampTo(-80, 4)
            setTimeout(() => {
                players.waitArp.stop()
            }, 4000)
        }
    }
    Vue.prototype.$scanAudio = (start) => {
        players.bassF.set("volume", -18)
        players.scanArp.set("volume", -18)
        if (start) {
            Vue.prototype.$sound('finger')
            setTimeout(() => {
                console.log("SCAN AUDIO");
                players.bassF.start()
                players.scanArp.start()
            }, 500)
        } else {
            Vue.prototype.$sound('chime')
            players.bassF.volume.rampTo(-80, 4)
            players.scanArp.volume.rampTo(-80, 4)
            setTimeout(() => {
                players.bassF.stop()
                players.scanArp.stop()
            }, 4000)
        }
    }
}

export default install